import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { AddEditNotification, DeleteInfo, SubscribedNotification, subscribedNotification, SubscribedToNotificationJson } from 'src/app/shared/models/notification.model';
import { User } from 'src/app/shared/models/user.model';
import { AddEditNotificationComponent } from './add-edit-notification/add-edit-notification.component';

@Component({
  selector: 'app-notificationbanner',
  templateUrl: './notificationbanner.component.html',
  styleUrls: ['./notificationbanner.component.scss']
})
export class NotificationbannerComponent implements OnInit {
  
  notificationAddEditTag : boolean = false;
  notificationPendingTag : boolean = true;
  submitBtn: boolean = false;
  deleteBtn: boolean = false;

  @Output() closeNotification = new EventEmitter();
  @Output() notificationCountVal = new EventEmitter();
  @Output() appSettingsClose = new EventEmitter();

  
  private unsubscribe: Subject<void> = new Subject<void>();
  usersInfo: User;
  notificationList: any;
  isManageList: boolean;
  isSubmitButtonAvailable: boolean;
  isAddFormVisible: boolean;
  isEditFormVisible: boolean;
  isDeleteButtonVisisble: boolean;

  @ViewChild(AddEditNotificationComponent) private addEditNotificationComponent: AddEditNotificationComponent;
  formData: any;
  isSaveValid: boolean;
  formFilesAndSupplierInfo: any;
  addStep: number = 0;
  hasSupplierSelection: boolean = false;

  constructor(private userRepositoryService: UserRepositoryService,
              private snackBarService: SnackBarService,) { }

  ngOnInit(): void {
    this.userRepositoryService.loggedUserData$.pipe(
      takeUntil(this.unsubscribe)).subscribe((user: User) => {
        if(user) {
          this.usersInfo = user;
          this.getNotificationDetails(this.usersInfo.cwsId);
        }
      });
    this.isManageList = true;
    this.isSaveValid = true;
  }

  getNotificationDetails(cwsId) {
    this.userRepositoryService.getNotificationsInfoByUserId(cwsId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((notificationList) => {
        if(notificationList && notificationList.subscribedNotification) {
          this.notificationList = notificationList.subscribedNotification;
          this.isManageList = true;
        } else {
          this.isManageList = true;
        }
      });
  }

  onSaveClick() {
   if (!this.addEditNotificationComponent.editForm) {
     let addPayload: AddEditNotification = this.addEditNotificationComponent.getAddPayload(this.usersInfo.cwsId);
     this.userRepositoryService.saveNotification(addPayload)
       .pipe(takeUntil(this.unsubscribe))
       .subscribe(data => {
         if (data) {
           this.snackBarService.showSuccess('Supplier Notification has been successfully added/updated');
           this.notificationPendingTag = true;
           this.closeNotification.emit('close');
         }
       });
     return;
   }
   let formData = this.addEditNotificationComponent.notificationForm.controls;
   let editFormData = this.addEditNotificationComponent.editFormDetails;
   let supplierExist: boolean;
   let subscribeNotification: AddEditNotification = {
    id: '',
    userId: this.usersInfo.cwsId,
    subscribedToNotificationJson: {
    subscribedNotification: [{
    supplierId: this.addEditNotificationComponent.editForm == true ? editFormData.supplierId : formData.supplier.value.id,
    supplierName: this.addEditNotificationComponent.editForm == true ? editFormData.supplierName : formData.supplier.value.supplierName,
    notificationEvents: {
      isUpload: this.addEditNotificationComponent.notificationForm.controls.uploaded.value
    },
    documentTypes: {
      isAllDocumentType: formData.documentType.value == 0 ? true : false,
      selectedDocumentTypes: this.addEditNotificationComponent.isAllDocSelected == true ? this.formFilesAndSupplierInfo.subscribedList : []
    },
    notificationType:{
      inAppNotification: formData.inAppNotification.value == null ? false : formData.inAppNotification.value,
      emailNotification: {
        perDocument: formData.perDocument.value == null ? false : formData.perDocument.value,
        // weeklyNotification: ['']
        weeklyNotification: formData.weeklyNotification.value == null ? false : formData.weeklyNotification.value
      }
    },
    organizationCode: editFormData ? editFormData.organizationCode : formData.supplier.value.organizationCode,
    uploadCount: 0,
    downloadCount: 0,
    movedCount: 0
    }]
    },
    comments: ''
   }
  
   if(!editFormData && this.notificationList) {
    supplierExist = this.onSaveCheckDuplicateRecord(subscribeNotification.subscribedToNotificationJson);
   }
    if (!supplierExist) {
      this.userRepositoryService.saveNotification(subscribeNotification)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(data => {
          if (data) {
            this.snackBarService.showSuccess('Supplier Notification has been successfully added/updated');
            this.notificationPendingTag = true;
            this.closeNotification.emit('close');
          }
        });
    } else {
      this.addEditNotificationComponent.notificationForm.controls.supplier.setErrors({ inUserExists: true });
    }
  }

  onSaveCheckDuplicateRecord(data) {
    let selectedValue = data.subscribedNotification[0].supplierId
    for(var i=0;i<this.notificationList.length;i++)
    {
        if(this.notificationList[i].supplierId === selectedValue){return true;}
    }
    return false;
  }

  addClickInfo(event) {
    this.formFilesAndSupplierInfo = event; 
    this.formFilesAndSupplierInfo.subscribedList = this.addEditNotificationComponent.subscribedList;
  }

  onCancelClick(event) {
      if(this.addEditNotificationComponent.editForm && event.event > -1) {
        this.formFilesAndSupplierInfo = event;
        this.formFilesAndSupplierInfo.subscribedList.splice(event.event, 1);
      } 
      if(event > -1) {
        this.addEditNotificationComponent.subscribedList.splice(event, 1);
        this.formFilesAndSupplierInfo.subscribedList = this.addEditNotificationComponent.subscribedList;
      }
  }

  hasSaveEnable(event) {
    this.isSaveValid = event;
  }

  onSubmitButtonAvailable(event) {
    this.isSubmitButtonAvailable = event;
  }

  onStepChanged(step: number) {
    this.addStep = step;
  }

  onSupplierSelectionChange(hasSelection: boolean) {
    this.hasSupplierSelection = hasSelection;
  }

  onNextClick() {
    this.addEditNotificationComponent.goToConfigStep();
  }
  
  clickManage(){
    this.notificationAddEditTag = true;
    this.notificationPendingTag = false;
    this.isManageList = false;
  }

  onClickToBack(event) {
    this.isAddFormVisible = event.isAddFormVisible;
    this.isEditFormVisible = event.isEditFormVisible;
    this.isDeleteButtonVisisble = false;
  }

  onAddLinkClick(event) {
    this.isAddFormVisible = event.isAddFormVisible;
    this.isEditFormVisible = event.isEditFormVisible;
  }

  onEditIconClick(event) {
    this.isAddFormVisible = event.isAddFormVisible;
    this.isEditFormVisible = event.isEditFormVisible;
    this.isDeleteButtonVisisble = event.isDeleteButtonVisisble;
  }

  onDeleteClick() {
    let deleteNotification: DeleteInfo = {
      userId: this.usersInfo.cwsId,
      supplierId: this.addEditNotificationComponent.editFormDetails.supplierId
    }
    this.userRepositoryService.deleteNotification(deleteNotification)
   .pipe(takeUntil(this.unsubscribe))
   .subscribe(data => {
      if(data) {
        this.snackBarService.showSuccess('Supplier Notification has been successfully deleted');
        this.closeNotification.emit('close');
      }
   });
  }

  pendingTagShow(count){
    this.notificationAddEditTag = false;
    this.notificationPendingTag = true;
    this.isManageList = true;
  }

  notificationwindowClose(){
    //this.closeNotification.emit('close');
    this.isSubmitButtonAvailable ? this.addEditNotificationComponent.backToNotificationManage() : this.closeNotification.emit('close');
    this.appSettingsClose.emit('close');
  }

  onclickuploadCount(event) {
    this.closeNotification.emit(event.value);
  }

  notificationCount(event){
    this.notificationCountVal.emit(event);
  }
}
